import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import CloseButton from 'components/CloseButton';
import SimpleFileUpload from 'components/FileUpload/layout/SimpleFileUpload';
import { useFormikContext } from 'formik';
import { paletteBackground } from 'models/Theme';

import ChangeImageSvg from '@common/assets/icons/PhotoEdit.svg';
import concentrationBanner from '@common/assets/images/profile-background-default.webp';
import spaceBanner from '@common/assets/images/profile-background-space.webp';

import {
	StyledProfilePopoverBannerButton,
	StyledProfilePopoverBannerCloseWrap,
	StyledProfilePopoverBannerImage,
	StyledProfilePopoverBannerWrap,
} from './styled';

type PropsType = {
	name: string;
};

const getDefaultBanner = (background: any) => {
	switch (background) {
		case paletteBackground.space:
			return spaceBanner;
		case paletteBackground.concentration:
		default:
			return concentrationBanner;
	}
};

function ProfilePopoverBanner({ name }: PropsType) {
	const { t } = useTranslation();
	const { values, setFieldValue } = useFormikContext<any>();

	const handleSetDefaultBanner = useCallback(() => {
		setFieldValue('banner', getDefaultBanner(values.background));
	}, [values.background]);

	useEffect(() => {
		if (values.banner.startsWith('https')) return;

		setFieldValue('banner', getDefaultBanner(values.background));
	}, [values.background]);

	const isCustom = values.banner.startsWith('https');

	const imageSrc = isCustom ? values.banner : getDefaultBanner(values.background);

	return (
		<>
			<StyledProfilePopoverBannerWrap>
				{isCustom && (
					<StyledProfilePopoverBannerCloseWrap>
						<CloseButton background onClick={handleSetDefaultBanner} />
					</StyledProfilePopoverBannerCloseWrap>
				)}
				<StyledProfilePopoverBannerImage src={imageSrc} alt="Banner" />
			</StyledProfilePopoverBannerWrap>
			<SimpleFileUpload name={name} maxSize={15}>
				<StyledProfilePopoverBannerButton variant="text">
					<ChangeImageSvg />
					<Typography variant="subtitle1">{t('themeModal.changeBanner')}</Typography>
				</StyledProfilePopoverBannerButton>
			</SimpleFileUpload>
		</>
	);
}

export default ProfilePopoverBanner;
